import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'
import 'firebase/storage'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

const firebaseEnabled = [
  firebaseConfig.apiKey,
  firebaseConfig.authDomain,
  firebaseConfig.projectId,
  firebaseConfig.storageBucket,
  firebaseConfig.messagingSenderId,
  firebaseConfig.appId
].every(Boolean)

let db = null
let storage = null
let storageRef = null
let auth = null

if (firebaseEnabled) {
  const app = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig)

  if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
    try {
      firebase.analytics()
    } catch (error) {
      console.log(error)
    }
  }

  db = app.firestore()
  storage = app.storage()
  storageRef = storage.ref()
  auth = app.auth()
}

// db.settings({ timestampsInSnapshots: true });

export { db, storage, storageRef, auth, firebaseEnabled }